import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { clearActivityDetailInfo, fetchActivity, getActivitySinglePageDetails } from '../../../store/slices/catalogSlice';
import SingleLanding from '../SingleLanding';

const defaultImage = require('../../../resources/images/chat/title.svg');

const ActivityLanding = () => {
    const { activityId } = useParams();
    const { loading, data: activity, error } = useSelector(getActivitySinglePageDetails);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchActivity(activityId));
    }, [activityId, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(clearActivityDetailInfo());
        };
    }, [dispatch]);

    return (
        <>
            {activity && (
                <Helmet>
                    <title>{`${activity.title} — Veda AI by Astrology.com`}</title>
                    <meta name="description" content={activity?.description || ''} />
                </Helmet>
            )}
            <SingleLanding
                loading={loading}
                advisor={{
                    images: activity?.advisor?.landing?.images,
                    strings: activity?.advisor?.landing?.strings
                }}
                iconPath={defaultImage}
                altText={activity?.title || ''}
                error={error}
                title={activity?.title}
                subtitle={activity?.description || ''}
                advisorAlias={activity?.advisor?.alias}
                isActivity={true}
                activityId={activityId}
            />
        </>
    );
};

export default ActivityLanding;
